import { Expose, Type } from 'class-transformer'
import { Category as CateogryIcon } from '@material-ui/icons'
import { Package } from 'react-feather'

import { Base } from './Base'
import { Container } from './Container'
import { Place } from './Place'
import { Product } from './Product'
import { ProductImage } from './ProductImage'

export class BarcodedUnit extends Base {
  static type = 'unit'
  static typeDisplay = 'Barcoded Unit'
  static icon = Package

  type = BarcodedUnit.type
  typeDisplay = BarcodedUnit.typeDisplay
  icon = BarcodedUnit.icon

  static Icon = CateogryIcon

  Icon = CateogryIcon

  @Expose({ name: 'xid' })
  guid: string = ''

  @Expose({ name: 'xid' })
  name: string = ''

  @Type(() => Product)
  product?: Product

  @Type(() => Place)
  place?: Place

  @Type(() => Container)
  container?: Container

  @Type(() => ProductImage)
  images?: ProductImage[] = []

  get location() {
    if (this.place) {
      return this.place
    }
    return this.container
  }

  get facility() {
    if (this.location) {
      return this.location.facility
    }
    return null
  }

  get path() {
    const items = []
    if (this.location) {
      items.push(this.location.path)
    }
    items.push(this.name)
    return items.join(' > ')
  }

  get objPath() {
    const items = []
    if (this.location) {
      items.push(...this.location.objPath)
    }
    items.push(this)
    return items
  }
}
